/**
 * Submit Bug Environment enums used by the JIRA Submit a Bug to determine where bug is being submitted.
 */
export enum SubmitBugEnvironment {
  PRODUCTION_ENVIRONMENT = 'production',
  SANDBOX_ENVIRONMENT = 'sandbox',
  LOCAL_ENVIRONMENT = 'sandbox',
}
